import {
  Badge,
  FieldText,
  FlexBox,
  Icon,
  IconButton,
  Radio,
} from '@dixa/lib-shared-habla';
import { Field } from 'redux-form';

import { FieldRepeaterRowProps } from 'fable/fieldRepeater/fieldRepeater';

type OwnProps = {
  type: 'email' | 'phone';
  selectedIndex: number;
  onSelect: (index: number) => void;
  disabled?: boolean;
  disabledPrimary?: boolean;
};
type ContactPointFieldProps = FieldRepeaterRowProps<OwnProps>;

export const ContactPointField = ({
  disabled,
  disabledPrimary,
  field,
  index,
  selectedIndex,
  totalRows,
  type,
  onSelect,
  onRemove,
}: ContactPointFieldProps): JSX.Element => {
  const isSelected = index === selectedIndex;

  /**
   * Calls remove callback and updates selected index if removed index precedes
   * it, to avoid changing selected value.
   */
  const onContactPointRemove = () => {
    if (index < selectedIndex) onSelect(selectedIndex - 1);
    onRemove(index);
  };

  return (
    <FlexBox margin="0 0 200 0">
      <Field
        component={FieldText}
        disabled={disabled || disabledPrimary ? isSelected : false}
        name={`${field}.value`}
        noLabel={true}
        type={type}
        prefix={
          {
            type: 'custom',
            value: <Icon name={type === 'email' ? 'mail' : 'phone'} />,
          } as never
        }
        suffix={{
          type: 'custom',
          noWrap: true,
          value: (
            <FlexBox alignItems="center" gap="200">
              {isSelected && (
                <Badge variant="primary" size="small">
                  Primary
                </Badge>
              )}
              <Radio
                checked={isSelected}
                id={`${field}${index}`}
                disabled={disabled || disabledPrimary}
                onChange={() => onSelect(index)}
              />
            </FlexBox>
          ),
        }}
        placeholder={`Enter contact’s ${
          type === 'email' ? 'email' : 'phone number'
        }`}
      />

      <FlexBox margin="100 0 0 200">
        <IconButton
          icon="trash"
          variant="tertiary"
          type="button"
          disabled={
            disabled || totalRows === 1 || disabledPrimary ? isSelected : false
          }
          onClick={onContactPointRemove}
        />
      </FlexBox>
    </FlexBox>
  );
};
